var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-site"}},[_c('factory-status-legend'),_c('building-lines',{style:(("zoom: " + _vm.zoom + "%;")),attrs:{"assets":_vm.siteAssets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }